module.exports = __webpack_public_path__ + "img/ico-breast-cancer-90-x-90.f6707bfd.svg";